import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useI18n } from 'vue-i18n'

import InputTip from '@C/ui/popover/InputTip.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'InputTipUsername',
  setup(__props) {

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputTip, {
    class: "input-tip__username",
    "offset-skid": "97",
    "arrow-padding": "200"
  }, {
    content: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_unref(t)('signupPage.usernameCantBeChanged')), 1)
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})